import { render, staticRenderFns } from "./DirectSignup.vue?vue&type=template&id=606b1ca7&scoped=true"
import script from "./DirectSignup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DirectSignup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DirectSignup.vue?vue&type=style&index=0&id=606b1ca7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606b1ca7",
  null
  
)

export default component.exports